<template>
  <el-dialog
    title
    :visible.sync="show"
    :close-on-click-modal="false"
    width="700px"
    class="edit-modal "
    :append-to-body="true"
    @close="onChange"
  >
    <div slot="title">
      {{ $t('shop-site::google_manager::title') }}
    </div>
    <el-button type="primary" size="medium" @click="handleBtn('add')">
      {{ $t('shop-site::google_manager::add_button') }}
    </el-button>

    <z-table
      class="user-body"
      ref="table"
      :data="tableData"
      :columns="columns"
      :pagination="false"
      style="width: 100%;margin-top:10px;"
      height="300"
      v-loading="loading"
    >
      <template #operation="{ row }">
        <el-button type="text" @click="handleBtn('edit', row)">
          {{ $t('shop-site::google_manager::table_edit') }}
        </el-button>
        <el-button type="text" @click="empower(row)">
          重新授权
        </el-button>
      </template>
    </z-table>

    <div slot="footer" class="dialog-footer">
      <el-button @click="onChange">{{ $t('system::common::btn::close') }}</el-button>
    </div>
    <editManagerModal v-model="showAccountModal" :drawRow="drawRow" @save="getManagerList"></editManagerModal>
  </el-dialog>
</template>
<script>
import { getGoogleManagerList, accountEmpower } from '@/server/marketing.js'
import editManagerModal from './edit-manager-modal'
export default {
  name: 'token-modal',
  components: { editManagerModal },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    }
  },
  watch: {
    visible(bool) {
      this.show = bool
      if (bool) {
        this.getManagerList()
      } else {
        this.$emit('close')
      }
    },
    drawRow: {
      handler: function(data) {},
      deep: true
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      show: false,
      showAccountModal: false,
      btnLoading: false,
      drawRow: {
        type: 'write',
        item: {}
      },
      columns: [
        {
          label: this.$t('shop-site::google_manager::table_account'),
          prop: 'customerId'
        },
        {
          label: this.$t('shop-site::google_manager::table_token'),
          prop: 'developerToken'
        },
        {
          label: '状态',
          prop: 'status',
          formatter(row) {
            return row.status ? '已授权' : '未授权'
          }
        },
        {
          prop: 'operation',
          label: this.$t('shop-site::google_manager::table_hanlde'),
          width: '180px'
        }
      ]
    }
  },
  mounted() {},
  methods: {
    handleBtn(type, row) {
      this.drawRow.type = type
      if (row) {
        this.drawRow.item = row
      }
      this.showAccountModal = true
    },
    async getManagerList() {
      this.loading = true
      const { data } = await getGoogleManagerList()
      if (data.code === this.$code) {
        this.tableData = data.data
      }
      this.loading = false
    },
    onChange() {
      this.$emit('change', false)
    },
    async empower(row) {
      this.btnLoading = true
      const { data } = await accountEmpower(row.id)
      this.btnLoading = false
      if (data.code === this.$code) {
        window.location.href = data.data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-modal {
  .modal-tip {
    margin-bottom: 12px;
  }
  .user-body {
    .input-item {
      width: 100%;
    }
  }
  .check-info {
    margin-bottom: 10px;
  }
  .tip-info {
    color: $--color-info;
  }
}
</style>
